const ACTIONS = {
  START_PAGE: "startPage",
};

export default ACTIONS;
